import { getApiBaseUrl } from 'hypo-shared-utils';

const workstationApiOrigin = {
  QA: 'https://workstation-qa-api.morningstar.com',
  STG: 'https://workstation-stg-api.morningstar.com',
  UAT: 'https://workstation-uat-api.morningstar.com',
  PROD: 'https://workstation-api.morningstar.com',
};

const getInvestmentFeeSchedulesForActual = async (secIds, env) => {
  const params = new URLSearchParams({});
  secIds.forEach(secId => {
    params.append('secIds', secId);
  });
  const url = `${
    workstationApiOrigin[env]
  }/api/v1/actual/get-private-model-fee-information?${params.toString()}`;
  return window.mwc.dataAccess
    .fetch({
      url,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    })
    .then(res => {
      if (res.status !== 401) {
        return res.json();
      }
      return [];
    });
};

const getAdvisoryFeeSchedulesFromApi = async (userId, isExternalUser, env) => {
  const params = new URLSearchParams({
    userId,
    isGuid: !isExternalUser,
    isNewVersion: true,
  });
  const url = `${getApiBaseUrl(
    '/api/v1/newfeeschedule/getnewfeeschedule',
    env
  )}?${params.toString()}`;
  return window.mwc.dataAccess
    .fetch({
      url,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => res.json());
};

const getFundFamiliesDataFromApi = async (tokenSource, env, secIds, languageId = 'en-US') => {
  return window.mwc.dataAccess
    .fetch({
      source: tokenSource,
      url: `${workstationApiOrigin[env]}/api/v1/hypocloud/security/fundfamily?languageId=${languageId}`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(secIds),
    })
    .then(res => res.json());
};

const getSMASecuritiesBaseInfoFromApi = async (secIds, languageId, env) => {
  const urlParams = new URLSearchParams({
    languageId,
  });
  const url = `${
    workstationApiOrigin[env]
  }/api/v1/hypocloud/security/basic?${urlParams.toString()}`;
  return window.mwc.dataAccess
    .fetch({
      url,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(secIds),
    })
    .then(res => {
      if (res.status !== 401) {
        return res.json();
      }
      return [];
    });
};

const getScheduleFromApi = async (securities, tokenSource, environment) => {
  const secIds = securities.map(item => item.securityId);
  return window.mwc.dataAccess
    .fetch({
      source: tokenSource,
      url: `${workstationApiOrigin[environment]}/api/v1/hypocloud/feeschedule`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(secIds),
    })
    .then(res => {
      if (res.status !== 401) {
        return res.json();
      }
      return [];
    });
};

const getAnnuityFromApi = async (securities, tokenSource, environment) => {
  const vaSecIds = [];
  securities.forEach(sec => {
    // Only process VA securites that lack basic annuity Info
    if (sec.securityType === 'VA') {
      vaSecIds.push(sec.securityId);
    }
  });
  if (vaSecIds.length === 0) {
    return [];
  }
  return window.mwc.dataAccess
    .fetch({
      source: tokenSource,
      url: `${getApiBaseUrl('/api/v1/fee/getpolicylist', environment)}`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(vaSecIds),
    })
    .then(res => res.json());
};

export {
  getInvestmentFeeSchedulesForActual,
  getAdvisoryFeeSchedulesFromApi,
  getFundFamiliesDataFromApi,
  getSMASecuritiesBaseInfoFromApi,
  getScheduleFromApi,
  getAnnuityFromApi,
};
